<div class="collection-page">

  <section class="panel-card collection-list-panel">
    <div class="panel-header">
      <div class="header-titles">
        <h1>Collection Management</h1>
        <p class="subtitle">Create and manage collections to organize items for your catalog.</p>
      </div>
      <button mat-flat-button color="primary" class="create-btn" (click)="createNewCollection()">
        <mat-icon>add</mat-icon> Create Collection
      </button>
    </div>

    <div class="list-toolbar">
      <div class="search-box">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search collections..." [(ngModel)]="listSearch"
          (ngModelChange)="onListSearch()" />
      </div>
      <button mat-stroked-button class="filters-btn">
        <mat-icon>tune</mat-icon> Filters
      </button>
    </div>

    <div class="table-wrap">
      <table class="collection-table">
        <thead>
          <tr>
            <th class="th-drag"></th>
            <th class="th-name">Collection Name</th>
            <th class="th-items">Items</th>
            <th class="th-visible">Visible</th>
            <th class="th-order">Order</th>
            <th class="th-actions">Actions</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="onRowDrop($event)">
          <tr *ngFor="let row of filteredCollections" cdkDrag [cdkDragData]="row"
            [class.active]="getCollectionId(selectedCollection) === getCollectionId(row)" (click)="selectCollection(row)">
            <td class="drag-handle-cell" cdkDragHandle (click)="$event.stopPropagation()">
              <mat-icon>drag_indicator</mat-icon>
            </td>
            <td class="name-cell">{{ row.name }}</td>
            <td>{{ row.itemsCount || 0 }} Items</td>
            <td><span class="dot" [class.on]="row.visible"></span> {{ row.visible ? 'Yes' : 'No' }}</td>
            <td>{{ row.order }}</td>
            <td class="actions-cell" (click)="$event.stopPropagation()">
              <button mat-icon-button matTooltip="Edit" (click)="selectCollection(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Delete" color="warn" [disabled]="deleting"
                (click)="deleteCollection(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="filteredCollections.length === 0">
            <td colspan="6" class="empty-row">No collections found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-footer" *ngIf="filteredCollections.length">
      <span class="footer-count">Showing 1 to {{ filteredCollections.length }} of {{ collections.length }} collections</span>
      <span class="drag-hint">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="8.5" cy="4.5" r="1.5"/><circle cx="15.5" cy="4.5" r="1.5"/>
          <circle cx="8.5" cy="12" r="1.5"/><circle cx="15.5" cy="12" r="1.5"/>
          <circle cx="8.5" cy="19.5" r="1.5"/><circle cx="15.5" cy="19.5" r="1.5"/>
        </svg>
        Drag rows to reorder
      </span>
    </div>
  </section>

  <section class="panel-card collection-detail-panel">
    <div class="detail-header">
      <h2>{{ isNew ? 'New Collection' : selectedCollection?.name }}</h2>
      <div class="detail-actions">
        <button mat-stroked-button color="warn" class="delete-btn" [disabled]="deleting" (click)="deleteCollection()">
          <mat-icon>delete</mat-icon> Delete Collection
        </button>
        <button mat-icon-button class="collapse-btn" type="button">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </div>

    <form [formGroup]="collectionForm" (ngSubmit)="submit()">
      <div class="details-grid">

        <div class="field-block details-col">
          <h4>Collection Details</h4>

          <label>Collection Name <span class="req">*</span></label>
          <input type="text" formControlName="name" maxlength="100" placeholder="Enter collection name" />
          <div class="char-count">{{ nameCharCount }}/100</div>

          <label class="mt">Show in Catalog</label>
          <div class="radio-row">
            <label class="radio-option">
              <span class="radio-line">
                <input type="radio" [value]="true" formControlName="showInCatalog" />
                Yes, show in catalog
              </span>
              <span class="hint">Visible to all catalog visitors</span>
            </label>
            <label class="radio-option">
              <span class="radio-line">
                <input type="radio" [value]="false" formControlName="showInCatalog" />
                No, hide from catalog
              </span>
              <span class="hint">Can be published later</span>
            </label>
          </div>

          <label class="mt">Sort Order <span class="req">*</span></label>
          <input type="number" min="1" formControlName="sortOrder" class="sort-input" />
          <div class="hint">Lower numbers appear first.</div>
        </div>

        <div class="field-block banner-block">
          <h4>Collection Banner <span class="req">*</span></h4>

          <div class="banner-two-col">
            <div class="banner-upload-col">
              <label class="banner-upload-box">
                <mat-icon>cloud_upload</mat-icon>
                <span>Upload Banner</span>
                <small>PNG, JPG or WebP<br>Max file size: 5 MB</small>
                <input type="file" accept="image/png,image/jpeg,image/webp" hidden
                  (change)="onBannerSelected($event)" />
              </label>
              <!-- <button type="button" class="flat-link-btn" (click)="resetCrop()">
                <mat-icon>restart_alt</mat-icon> Reset Crop
              </button> -->
            </div>

            <div class="banner-preview-col">
              <div class="banner-preview-box" [class.empty]="!bannerPreviewUrl">
                <img *ngIf="bannerPreviewUrl" [src]="bannerPreviewUrl" alt="Collection banner" />
                <div *ngIf="!bannerPreviewUrl" class="preview-placeholder">
                  <mat-icon>image</mat-icon>
                  <span>No banner selected yet</span>
                </div>
              </div>
             <!-- <button type="button" class="flat-link-btn crop-btn" (click)="autoCropAndResize()">
                <mat-icon>crop_free</mat-icon> Auto Crop & Resize
              </button> -->  
            </div>
          </div>

          <div class="banner-guidelines">
            <div class="guideline-header">
              <mat-icon class="guideline-icon">info</mat-icon>
              <strong class="guideline-title">Banner Guidelines</strong>
            </div>

            <div class="guideline-grid">
              <div class="guideline-item">
                <div class="item-label">
                  <span class="bullet">•</span>
                  <span>Recommended Size</span>
                </div>
                <div class="item-value">1584 x 672 px</div>
              </div>

              <div class="guideline-item">
                <div class="item-label">
                  <span class="bullet">•</span>
                  <span>Aspect Ratio</span>
                </div>
                <div class="item-value">21 : 9</div>
              </div>

              <div class="guideline-item">
                <div class="item-label">
                  <span class="bullet">•</span>
                  <span>Formats</span>
                </div>
                <div class="item-value">PNG, JPG or WebP</div>
              </div>

              <div class="guideline-item">
                <div class="item-label">
                  <span class="bullet">•</span>
                  <span>Max File Size</span>
                </div>
                <div class="item-value">5 MB</div>
              </div>

              <div class="guideline-item">
                <div class="item-label">
                  <span class="bullet">•</span>
                  <span>Auto Formatting</span>
                </div>
                <div class="item-desc">Resized & cropped to fit</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-footer">
        <div class="form-footer-buttons">
          <button type="button" mat-stroked-button class="cancel-btn" (click)="createNewCollection()">Cancel</button>
          <button type="submit" mat-flat-button color="primary" class="submit-btn" [disabled]="saving || submitDisabled">
            {{ saving ? 'Saving...' : 'Submit' }}
          </button>
        </div>
        <div class="form-footer-note" *ngIf="isNew">Save the collection to add items.</div>
      </div>
    </form>
  </section>

  <section class="panel-card how-it-works-panel">
    <h3>How it works</h3>

    <div class="steps-container">
      <div class="step-card">
        <div class="step-icon-box">
          <svg class="step-svg" width="32" height="36" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 2H15L21 8V24C21 25.1 20.1 26 19 26H4C2.9 26 2 25.1 2 24V4C2 2.9 2.9 2 4 2Z" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15 2V8H21" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 15.5H15.5M11.5 11.5V19.5" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="step-badge">1</div>
        <strong class="step-title">Create Collection</strong>
        <span class="step-desc">Add a name, banner image, visibility and sort order.</span>
      </div>

      <div class="step-separator">
        <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6H20M20 6L15 1.5M20 6L15 10.5" stroke="#94a3b8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="step-card">
        <div class="step-icon-box">
          <svg class="step-svg" width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L21 7.2V16.8L12 22L3 16.8V7.2L12 2Z" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 12L21 7.2" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 12V22" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 12L3 7.2" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="step-badge">2</div>
        <strong class="step-title">Add Items</strong>
        <span class="step-desc">Use the dual selector to add items or groups.</span>
      </div>

      <div class="step-separator">
        <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6H20M20 6L15 1.5M20 6L15 10.5" stroke="#94a3b8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="step-card">
        <div class="step-icon-box">
          <svg class="step-svg" width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="9" y1="6" x2="21" y2="6" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="9" y1="12" x2="21" y2="12" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round"/>
            <line x1="9" y1="18" x2="21" y2="18" stroke="#0f172a" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="4.5" cy="6" r="1.5" stroke="#0f172a" stroke-width="1.8"/>
            <circle cx="4.5" cy="12" r="1.5" stroke="#0f172a" stroke-width="1.8"/>
            <circle cx="4.5" cy="18" r="1.5" stroke="#0f172a" stroke-width="1.8"/>
          </svg>
        </div>
        <div class="step-badge">3</div>
        <strong class="step-title">Reorder & Save</strong>
        <span class="step-desc">Drag to reorder items in your collection and save changes.</span>
      </div>
    </div>

    <div class="tip-card">
      <div class="tip-icon-wrap">
        <mat-icon>lightbulb</mat-icon>
      </div>
      <span class="tip-text">
        <strong>Tip:</strong> You must save the collection before adding items.
      </span>
    </div>
  </section>

  <section class="panel-card collection-contents-panel">
    <div class="contents-header">
      <h4>
        Collection Contents
        <span class="contents-lock-note" *ngIf="isNew">
          <mat-icon>lock</mat-icon> Save the collection first to add items.
        </span>
      </h4>
    </div>

    <div class="collection-catalogue-wrapper">
      <div class="collection-catalogue-grid">
        <app-catalogue-template
          [productList]="availableProducts"
          [expand]="expandProduct"
          [moveProduct]="moveCollectionProduct('add')"
          headerTitle="Available Items & Item Groups"
          [isCurated]="false"
          info="Click to move an item or variant into this collection. Variants are loaded only when an item group is expanded.">
        </app-catalogue-template>

        <app-catalogue-template
          [productList]="collectionProducts"
          [expand]="expandProduct"
          [moveProduct]="moveCollectionProduct('subtract')"
          headerTitle="Items in Collection"
          [isCurated]="true"
          info="Click to remove an item or variant from this collection. This does not delete it from your products.">
        </app-catalogue-template>
      </div>

      <div class="collection-items-actions">
        <button type="button" mat-stroked-button class="save-items-btn" (click)="saveCollectionItems()" [disabled]="isNew">
          <mat-icon>save</mat-icon> Save Items
        </button>
      </div>
    </div>
  </section>

</div>